import { configureStore } from "@reduxjs/toolkit";
import staffReducer from "../features/services/staff/StaffSlice";
import UserSlice from "../features/services/user/UserSlice";

export const store = configureStore({
  reducer: {
    staff: staffReducer,
    user: UserSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
